export default __webpack_public_path__ + "static/media/landcalendergrey.f0b01ff8.svg";